import { render, staticRenderFns } from "./disablesale.vue?vue&type=template&id=c0fe78ce&scoped=true"
import script from "./disablesale.vue?vue&type=script&lang=js"
export * from "./disablesale.vue?vue&type=script&lang=js"
import style0 from "./disablesale.vue?vue&type=style&index=0&id=c0fe78ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fe78ce",
  null
  
)

export default component.exports